<template>
    <b-container>
        <b-row>
            <b-col>
                <h1 class="mt-4">Playlists</h1>
            </b-col>
            <b-col align="end">
                <b-button v-b-modal.addPlaylistModal variant="default" class="mt-4">Add new playlist</b-button>
            </b-col>
        </b-row>
        <b-table :current-page="currentPage" :per-page="perPage" class="mt-4" bordered :items="playlists" :fields="fields" striped>
            <template slot="actions" slot-scope="row">
                <b-button @click="getTracksForPlaylist(row.item._id, row, true)" class="mr-2">
                    <font-awesome-icon icon="music"></font-awesome-icon>
                </b-button>
                <b-button @click="editPlaylist(row.item, row.index, $event.target, row)" variant="info" class="mr-2"><font-awesome-icon icon="edit"></font-awesome-icon></b-button>
                <b-button @click="setPlaylistStatus(row.item, row.index, row)" :variant="row.item.active ? 'success' : 'danger'" class="mr-2"><font-awesome-icon icon="power-off"></font-awesome-icon></b-button>
                <b-button @click="deletePlaylist(row.item._id)" variant="danger" class="mr-2"><font-awesome-icon icon="trash"></font-awesome-icon></b-button>
            </template>

            <template slot="row-details" slot-scope="row">
                <b-card v-if="itemsLoaded">
                    <b-table bordered responsive hover :items="row.item.newTracks"></b-table>
                    <b-button size="sm" @click="row.toggleDetails">Hide Details</b-button>
                </b-card>
            </template>
        </b-table>
        <b-modal size="lg" title="Add Playlist" header-bg-variant="info" centered id="addPlaylistModal" @ok="doAddPlaylist" no-close-on-backdrop no-close-on-esc style="color: #FFFFFF">
            <div class="d-block" style="color: black">
                <h2>Add new playlist</h2>
                <b-form-input class="mt-3" v-model="name" type="text" placeholder="Playlist name" />
                <b-form-input class="mt-3" v-model="filter" type="text" placeholder="Filter tracks" />
                <b-pagination class="mt-4" v-model="currentPageTracks" :total-rows="tracks.length" :per-page="perPageTracks" size="md" />
                <b-table :filter="filter" :current-page="currentPageTracks" :per-page="perPageTracks" class="mt-4" bordered :items="tracks" :fields="fieldsTracks" striped>
                    <template slot="select" slot-scope="row">
                        <!-- As `row.showDetails` is one-way, we call the toggleDetails function on @change -->
                        <b-form-checkbox @change="addRemoveSelectedTracks(row.item._id)"></b-form-checkbox>
                    </template>
                </b-table>
            </div>
        </b-modal>
        <b-modal lazy size="lg" title="Edit Playlist" header-bg-variant="info" centered id="editPlaylistModal" @ok="savePlaylist" no-close-on-backdrop no-close-on-esc style="color: #FFFFFF">
            <div class="d-block" style="color: black">
                <h2>Edit playlist</h2>
                <b-form-input class="mt-3" v-model="name" type="text" placeholder="Playlist name" />
                <b-form-input class="mt-3" v-model="filter" type="text" placeholder="Filter tracks" />
                <b-pagination class="mt-4" v-model="currentPageTracks" :total-rows="tracks.length" :per-page="perPageTracks" size="md" />
                <b-table :filter="filter" :current-page="currentPageTracks" :per-page="perPageTracks" class="mt-4" bordered :items="tracks" :fields="fieldsTracks" striped>
                    <template slot="select" slot-scope="row">
                        <!-- As `row.showDetails` is one-way, we call the toggleDetails function on @change -->
                        <b-form-checkbox @change="addRemoveSelectedTracks(row.item._id)" :checked="shouldBeChecked(row.item._id)"></b-form-checkbox>
                    </template>
                </b-table>
            </div>
        </b-modal>
    </b-container>
</template>

<script>
    import { EventBus } from "../../EventBus";
    import _ from 'lodash';

    export default {
        name: "PlaylistsView",
        data() {
            return {
                playlists: [],
                fields: ['name', 'actions'],
                tracks: [],
                fieldsTracks: ['artist', 'track', 'genre', 'select'],
                perPage: 50,
                currentPage: 1,
                perPageTracks: 50,
                currentPageTracks: 1,
                name: '',
                selectedTracks: [],
                filter: '',
                editPlaylistModal: { data: {} },
                activePlaylistId: '',
              itemsLoaded: false
            }
        },
        mounted() {
            this.getAllPlaylists();
            this.getAllTracks();
        },
        methods: {
            async getTracksForPlaylist(id, row, showToggle) {

              if (showToggle) {
                row.toggleDetails();
                EventBus.$emit('loading-show');
                this.itemsLoaded = false;
              }

              await this.$axios.get(`playlists/${id}`).then(result => {
                row.item.newTracks = result.data.tracks;
                this.itemsLoaded = true;
                EventBus.$emit('loading-hide');
                return Promise.resolve(row);
              }).catch(err => {
                EventBus.$emit('loading-hide');
                EventBus.$emit('message', {message: err.message, type: 'danger'});
                return Promise.reject('Error');
              });
            },
            getAllTracks() {
                EventBus.$emit('loading-show');
                this.$axios.get('tracks').then(result => {
                    EventBus.$emit('loading-hide');
                    this.tracks = result.data;
                }).catch(err => {
                    EventBus.$emit('loading-hide');
                    EventBus.$emit('message', {message: err.message, type: 'danger'});
                });
            },
            getAllPlaylists() {
                EventBus.$emit('loading-show');
                this.$axios.get('playlists/all').then(result => {
                    EventBus.$emit('loading-hide');
                    this.playlists = result.data;
                }).catch(err => {
                    EventBus.$emit('loading-hide');
                    EventBus.$emit('message', {message: err.message, type: 'danger'});
                });
            },
            doAddPlaylist() {
                EventBus.$emit('loading-show');
                if (this.name.length > 0 && this.selectedTracks.length > 0) {
                    this.$axios.post('playlists', {name: this.name, tracks: this.selectedTracks}).then(() => {
                        EventBus.$emit('loading-hide');
                        EventBus.$emit('message', {message: 'Playlist created successfully', type: 'success'});
                        this.name = '';
                        this.selectedTracks = [];
                        this.getAllPlaylists();
                    }).catch(err => {
                        EventBus.$emit('loading-hide');
                        EventBus.$emit('message', {message: err.message, type: 'danger'});
                    })
                }
            },
            addRemoveSelectedTracks(id) {
                if (this.selectedTracks.findIndex(x => x === id) > -1) {
                    this.selectedTracks.splice(this.selectedTracks.findIndex(x => x === id), 1);
                } else {
                    this.selectedTracks.push(id);
                }
            },
            async editPlaylist(item, index, button, row) {
                await this.getTracksForPlaylist(item._id, row, false);
                this.editPlaylistModal.data = this.playlists[index];
                this.name = this.playlists[index].name;
                this.activePlaylistId = this.playlists[index]._id;

                _.forEach(row.item.newTracks, (track) => {
                    this.selectedTracks.push(track._id.toString());
                });
                this.$root.$emit('bv::show::modal', 'editPlaylistModal', button)
            },
          deletePlaylist(id) {
            EventBus.$emit('loading-show');
            this.$axios.delete(`playlists/${id}`).then(() => {
              EventBus.$emit('loading-hide');
              EventBus.$emit('message', {message: 'Playlist deleted successfully', type: 'success'});
              this.getAllPlaylists();
            }).catch(err => {
              EventBus.$emit('loading-hide');
              EventBus.$emit('message', {message: err.message, type: 'danger'});
            });
          },
            async setPlaylistStatus(item, index, row) {
              EventBus.$emit('loading-show');
              await this.getTracksForPlaylist(item._id, row, false);
                this.activePlaylistId = this.playlists[index]._id;
                _.forEach(row.item.newTracks, (track) => {
                    this.selectedTracks.push(track._id.toString());
                });
                this.playlists[index].active = !this.playlists[index].active;

                this.$axios.put(`playlists/${this.activePlaylistId}`, {name: this.playlists[index].name, tracks: this.selectedTracks, active: this.playlists[index].active}).then(() => {
                    EventBus.$emit('loading-hide');
                    EventBus.$emit('message', {message: 'Playlist updated successfully', type: 'success'});
                    this.name = '';
                    this.selectedTracks = [];
                    this.activePlaylistId = '';
                    this.getAllPlaylists();
                }).catch(err => {
                    EventBus.$emit('loading-hide');
                    EventBus.$emit('message', {message: err.message, type: 'danger'});
                });
            },
            shouldBeChecked(id) {
                return this.selectedTracks.findIndex(x => x === id) > -1;
            },
            savePlaylist() {
                if (this.name.length > 0 && this.selectedTracks.length > 0) {
                    this.$axios.put(`playlists/${this.activePlaylistId}`, {name: this.name, tracks: this.selectedTracks}).then(() => {
                        EventBus.$emit('loading-hide');
                        EventBus.$emit('message', {message: 'Playlist updated successfully', type: 'success'});
                        this.name = '';
                        this.selectedTracks = [];
                        this.activePlaylistId = '';
                        this.getAllPlaylists();
                    }).catch(err => {
                        EventBus.$emit('loading-hide');
                        EventBus.$emit('message', {message: err.message, type: 'danger'});
                    });
                }
            }
        }
    }
</script>

<style scoped>

</style>
